import { z } from 'zod/v4';
import { createDefinitionSchema } from '../utils/helpers';

export type MockDataQuerySpec = z.infer<typeof MockDataQuerySpecSchema>;
const MockDataQuerySpecSchema = z.object({
  totalSeries: z.number(),
  totalDatapoints: z.number(),
  seed: z.number(),
  yVariationMultiplier: z.number(),
  randomnessMultiplier: z.number(),
  outlierRatio: z.number(),
  outlierMultiplier: z.number(),
  sparseRatio: z.number(),
});

export type MockDataQueryDefinition = z.infer<typeof MockDataQueryDefinitionSchema>;
export const MockDataQueryDefinitionSchema = createDefinitionSchema('MockDataQuery', MockDataQuerySpecSchema);
